<div id="init-release-table">
  <span class="section-title" id="init-release-transactions-header">
    Initiate & Release | Pending Requests
  </span>
  <mm-table [columnDefs]="columnDefs" [defaultColumnDefs]="isMasterAccountInContext ? subAccountDefs : masterAccountDefs" [rowData]="rowData$ | async" [showFloatingFilter]="true" [showTableOptions]="true"
    [showFilterCount]="true" [tableName]="tableName" [presetFilters]="filterModel" [rowHeight]="25" [headerHeight]="25"
    [fileName]="fileName" [showDisclaimerInfoIcon]="true" [componentState$]="InRtableState$" [noExportCol]="['Actions']">
  </mm-table>
  <mm-delete-initiated-draft-modal [showModal$]="deleteDraftClicked$.asObservable()"
    [currentDraft]="currentDraftInContext$.asObservable() | async" [isSloa]="isSloaInContext" [isFromReviewPage]="false">
  </mm-delete-initiated-draft-modal>
</div>
